import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.domains', {
        url: '/domains',
        component: 'companyDomains',
        resolve: {domains},
    })
}

function domains(companyId, DomainsService) {
    return DomainsService.query({companyId}).$promise;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/domains/domains.state.js